module.exports = __webpack_public_path__ + "static/img/web_home_2.c951cbb.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/extensionPage/web_home_2.png
// module id = xtL6
// module chunks = 0